export const solutionLinks = [
  {
    id: 'airlines',
    href: '/airlines',
    titleKey: 'solutionsMenu.airlines.title',
    descriptionKey: 'solutionsMenu.airlines.description',
    iconKey: 'airplaneTilt',
    analytics: 'airlines'
  },
  {
    id: 'iata-agencies',
    href: '/iata-agencies',
    titleKey: 'solutionsMenu.iataAgencies.title',
    descriptionKey: 'solutionsMenu.iataAgencies.description',
    iconKey: 'globe',
    analytics: 'agencies'
  },
  {
    id: 'non-iata-agencies',
    href: '/non-iata-agencies',
    titleKey: 'solutionsMenu.nonIataAgencies.title',
    descriptionKey: 'solutionsMenu.nonIataAgencies.description',
    iconKey: 'user',
    analytics: 'agencies'
  },
  {
    id: 'ota',
    href: '/ota',
    titleKey: 'solutionsMenu.ota.title',
    descriptionKey: 'solutionsMenu.ota.description',
    iconKey: 'bracketsCurly',
    analytics: 'agencies'
  }
]
